export enum customerType {
    Transshipment = 1,
    Fulfilment = 2,
    TransshipmentAndFulfilment = 3
}

// Enabled Channels for Customer
export enum CustomerChannels {
    Vietful = 19
}
